import Config from '@/config';
import http, { HttpPromise } from './http';

export default {
  organizations: {
    partnerList: (params) => http.get(`${Config.apiHost}/administrator/organizations/partnerList/`, { params }),
    customerList: (params) => http.get(`${Config.apiHost}/administrator/organizations/customerList/`, { params }),
    unauthorizedCounts: () => http.get(`${Config.apiHost}/administrator/organizations/unauthorizedCounts/`),
    details: (params) => http.get(`${Config.apiHost}/administrator/organizations/`, { params }),
    update: (params) => http.patch(`${Config.apiHost}/administrator/organizations/update/`, { ...params }),
    changeStatus: (params) => http.post(`${Config.apiHost}/administrator/organizations/changeStatus/`, { ...params }),
  },
  gencontractors: {
    list: (params) => http.get(`${Config.apiHost}/administrator/gencontractors/list/`, { params }),
    detail: (params) => http.post(`${Config.apiHost}/administrator/gencontractors/detail/`, { ...params }),
    confirm: (params) => http.post(`${Config.apiHost}/administrator/gencontractors/confirm/`, { ...params }),
    reject: (params) => http.post(`${Config.apiHost}/administrator/gencontractors/reject/`, { ...params }),
    block: (params) => http.post(`${Config.apiHost}/administrator/gencontractors/block/`, { ...params }),
  },
  users: {
    changeStatus: (params) => http.post(`${Config.apiHost}/administrator/users/changeStatus/`, { ...params }),
    downloadReport: () => http.post(`${Config.apiHost}/administrator/users/report/`, { responseType: 'blob' }),
    getUserRoles: () => http.post(`${Config.apiHost}/administrator/users/roles/`, {}),
  },
  contractors: {
    search: (filter) => http.post(`${Config.apiHost}/administrator/contractors/search/`, { filter }),
  },
  objects: {
    list: (params) => http.get(`${Config.apiHost}/administrator/objects/list/`, { params }),
    details: (params) => http.post(`${Config.apiHost}/administrator/objects/detail/`, { ...params }),
    saveContractors: (params) => http.post(`${Config.apiHost}/administrator/objects/changeContractorRelation/`, { ...params }),
    customersNotifyList: (objectId) => http.get(`${Config.apiHost}/administrator/objects/customersNotify/?objectId=${objectId}`),
    saveCustomersList: (data) => http.patch(`${Config.apiHost}/administrator/objects/customerNotification/`, { ...data }),
  },
  lots: {
    getPlannedLotsFile: () => http.get(`${Config.apiHost}/administrator/plannedLotsFile/`),
    loadMaterialGuideFile: () => http.get(`${Config.apiHost}/administrator/materialsGuideFile/`),
    updatePlannedLotsFile: (data) => http.post(`${Config.apiHost}/administrator/plannedLotsFile/update/`, { ...data }),
  },
  materials: {
    loadFile: (data) => http.post(`${Config.apiHost}/administrator/materialsGuideFile/update/`, { ...data }),
    downloadReport: () => http.get(`${Config.apiHost}/administrator/materialsGuideFile/report/`, { responseType: 'blob' }),
  },
};
